import { observer } from 'mobx-react-lite'
import { UserInfoItemListDialog } from '@/features/user-management/UserInfoItemListDialog'
import { type UserInfoItemListDialogViewModel } from './UserInfoItemListDialogViewModel'

export interface UserInfoItemListDialogContainerProps {
  vm: UserInfoItemListDialogViewModel
}

export const UserInfoItemListDialogContainer = observer(
  function UserInfoItemListDialogContainer({
    vm,
  }: UserInfoItemListDialogContainerProps) {
    return (
      <UserInfoItemListDialog
        showing={vm.modal.showing}
        onClose={vm.close}
        title={vm.title}
        normalizedTitle={vm.normalizeString(vm.title)}
        items={vm.userInfoItems.map((item) => ({
          value: item,
          normalizedValue: vm.normalizeString(item),
        }))}
      />
    )
  },
)
